const TOKEN_KEY = 'triviaAuthToken';

export function getAuthToken() {
    return sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY);
}

export function setAuthToken(token) {
    if (!token) return;
    sessionStorage.setItem(TOKEN_KEY, token);
}

export function clearAuthToken() {
    sessionStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(TOKEN_KEY);
}
